const actionTypeIdentifier = 'E53F0D53-4422-4285-8C93-18F9A0CD7FA2';

export const fetchInvoiceDetails = `FETCH-INVOICE-DETAILS-${actionTypeIdentifier}`;
export const fetchInvoiceStatus = `FETCH-INVOICE-STATUS-${actionTypeIdentifier}`;
export const fetchBillingAccountNumber = `FETCH-INVOICE-BILLING-ACCOUNT-NUMBER-${actionTypeIdentifier}`;
export const fetchSubAccountNumber = `FETCH-INVOICE-SUB-ACCOUNT-NUMBER-${actionTypeIdentifier}`;
export const fetchAssignedUser = `FETCH-INVOICE-ASSIGNED-USER-${actionTypeIdentifier}`;
export const setInvoiceApprovedDateRequired = `SET-INVOICE-APPROVED-DATE-REQUIRED-${actionTypeIdentifier}`;

export const invoiceDetailsFormModel = {
    id: 0,
    billingAccountNumberId: null,
    billingAccountNumberDisplay: null,
    subAccountNumberId: null,
    subAccountNumberDisplay: null,
    client: null,
    vendor: null,
    invoiceNumber: null,
    status: null,
    currency: null,
    exchangeRate: null,
    invoiceDate: null,
    actualInvoiceMonth: null,
    invoiceExpectedDate: null,
    invoiceDueDate: null,
    invoiceApprovedDate: null,
    billingPeriodFrom: null,
    billingPeriodTo: null,
    rentalPeriodFrom: null,
    rentalPeriodTo: null,
    invoiceReceiptDate: null,
    assignedUserId: null,
    assignedUserDisplay: null,
    ediNumber: null,
    uploadDate: null,
    uploadedBy: null,
    creditNote: false,
    invoicePDF: null,
    totalAmountDue: '0.00',
    totalAmountToPay: '0.00',
    grossAmount: '0.00',
    noOfChargedSubscription: 0,
    remainingBalance: '0.00',
    totalTaxes: '0.00',
    totalNet: '0.00',
    lineItemsTotal: '0.00',
    accountLevelCharges: '0.00',
    usageCharges: '0.00',
    recurringCharges: '0.00',
    miscellaneousCharges: '0.00',
    payments: '0.00',
    latePaymentFees: '0.00',
    otherCharges: '0.00',
    checkNumber: null,
    amountPaid: '0.00',
    paymentDate: null,
    remitId: null,
    apVendorId: null
};